import { Injectable, Injector, inject } from "@angular/core";
import { IAggregate, ICardData, ICardAction } from "@tylertech/tyler-api-types";
import { ActionHandlerType, AGGREGATE_ACTION_HANDLERS, IAggregateActionHandler } from "../interfaces/injectionToken";

export interface AggregateActionHandlerConstructor
{
    new(...args: Array<unknown>): IAggregateActionHandler;
}

function getLazyActionHandler(injector: Injector, actionHandler: ActionHandlerType): () => IAggregateActionHandler
{
    let handler: IAggregateActionHandler;
    return () =>
    {
        return handler
            ?? (handler = injector.get(actionHandler));
    };
}

/** @deprecated - Enough of our AngularJs dependency has been removed that this can probably be refactored away now.  */
@Injectable()
export class AggregateActionHandlerRepository
{
    private readonly _handlers: ReadonlyArray<() => IAggregateActionHandler>;

    constructor()
    {
        const injector = inject(Injector);
        const aggregateActionHandlers = inject<ReadonlyArray<ReadonlyArray<ActionHandlerType>>>(AGGREGATE_ACTION_HANDLERS);

        this._handlers = aggregateActionHandlers.reduce(
            (list: Array<() => IAggregateActionHandler>, handlers: Array<ActionHandlerType>) =>
            {
                return list.concat(
                    handlers.map((handler => getLazyActionHandler(injector, handler))));
            },
            []);
    }

    find(aggregate: IAggregate, cardData: ICardData, action: ICardAction): IAggregateActionHandler | undefined
    {
        const deferredHandler = this._handlers.find(getHandler => getHandler().predicate(aggregate, cardData, action));
        if (!deferredHandler)
        {
            return undefined;
        }

        return deferredHandler();
    }
}
